<template>
    <div class="el-table-container">
        <el-form size="small" :inline="true" class="query-form" ref="searchForm" :model="searchForm"
                 @keyup.enter.native="refreshList(1)" @submit.native.prevent>
            <el-form-item prop="name" label="输入搜索：">
                <el-input v-model.trim="searchForm.name" maxlength="50" placeholder="请输入租户名称" clearable></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="refreshList(1)" size="small" icon="el-icon-search">查询</el-button>
                <el-button @click="reset()" size="small" icon="el-icon-refresh-right">重置</el-button>
            </el-form-item>
            <el-form-item class="f_r">
                <el-button v-if="hasPermission('lessee:list:add')" type="primary" size="small" icon="el-icon-plus"
                           @click="addEdit(null, 'add')">新增
                </el-button>
                <el-button v-if="hasPermission('lessee:list:del')" type="danger" size="small" icon="el-icon-delete"
                           @click="del()">批量删除
                </el-button>
                <el-button v-if="hasPermission('lessee:list:export')" size="small"
                           @click="exportData()"><i class="icon-piliangdaochu iconfont buIcon"/>
                    批量导出
                </el-button>
            </el-form-item>
        </el-form>
        <el-table
                :data="dataList"
                v-loading="loading"
                size="small" height="100%"
                class="table" border ref="multipleTable" row-key='id' @selection-change="selectionChangeHandle">
            <el-table-column fixed type="selection" :reserve-selection="true"></el-table-column>
            <el-table-column prop="tenantId" label="租户ID" show-overflow-tooltip></el-table-column>
            <el-table-column prop="tenantName" label="租户名称" show-overflow-tooltip></el-table-column>
            <el-table-column prop="tenantSetMealName" label="租户套餐">
                <template slot-scope="scope">
                    <span class="mealName el-tag el-tag--small" v-if="scope.row.tenantSetMealName">{{scope.row.tenantSetMealName}}</span>
                    <span class="mealName2 el-tag el-tag--small" v-else>自定义套餐</span>
                </template>
            </el-table-column>
            <el-table-column prop="effectiveSate" label="租户状态">
                <template slot-scope="scope">
                    <el-tag size="small" :type="scope.row.effectiveSate != 1 ? 'danger':''">
                        {{$dictUtils.getDictLabel("effectiveSate", scope.row.effectiveSate ,'')}}
                    </el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="effectiveStartTime" label="开始时间" show-overflow-tooltip></el-table-column>
            <el-table-column prop="effectiveEndTime" label="过期时间" show-overflow-tooltip></el-table-column>
            <el-table-column prop="createDate" label="创建时间" show-overflow-tooltip></el-table-column>
            <el-table-column fixed="right" label="操作">
                <template slot-scope="scope">
                    <el-button v-if="hasPermission('lessee:list:view')" type="text" size="small"
                               @click="addEdit(scope.row, 'view')">详情
                    </el-button>
                    <el-button v-if="hasPermission('lessee:list:edit')" type="text" size="small"
                               @click="addEdit(scope.row, 'edit')">修改
                    </el-button>
                    <el-button v-if="hasPermission('lessee:list:del')" type="text" size="small"
                               @click="del(scope.row.id)">删除
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <pagination :total="total" :page.sync="searchForm.current" :limit.sync="searchForm.size"
                    @pagination="refreshList"/>
        <ListForm ref="listForm" @refreshDataList="refreshList"></ListForm>
    </div>
</template>

<script>
    import ListForm from './listForm'

    export default {
        components: {ListForm},
        data() {
            return {
                searchForm: {
                    name: '',
                    current: 1,
                    size: 20,
                },
                dataList: [],
                total: 0,
                dataListSelections: [],
                loading: false,
            }
        },
        mounted() {
            this.refreshList()
        },
        methods: {
            refreshList(type) {
                if (type == 1) {
                    this.searchForm.current = 1
                }
                this.loading = true
                this.$axios(this.api.user.systemporaryauthorityList, this.searchForm, 'get').then(data => {
                    if (data && data.status) {
                        this.dataList = data.data.records
                        if (this.dataList.length == 0 && this.searchForm.current > 1) {
                            this.searchForm.current--
                            this.refreshList()
                        }
                        this.total = parseInt(data.data.total)
                    } else {
                        this.$message.error('查询失败');
                    }
                    this.loading = false
                })
            },
            // 新增编辑
            addEdit(row, method) {
                this.$refs.listForm.init(row, method)
            },
            // 导出
            exportData() {
                if (!this.dataList.length) {
                    this.$message.warning('暂无可导出的数据')
                    return
                }
                let ids = this.dataListSelections.map(item => {
                    return item.id
                })
                this.exportExcel(this.api.user.exportSysTemporaryAuthority, ids, '租户管理', 'post')
            },
            // 删除
            del(id) {
                let ids = [id];
                if (!id && !this.dataListSelections.length) {
                    this.$message.warning('请至少选择一条数据')
                    return
                }
                if(id && id == '1386663086613594113') {
                    this.$message.warning('该租户不允许被删除')
                    return;
                }
                if (!id) {
                    ids = this.dataListSelections.map(item => {
                        return item.id
                    }).filter(v => v != '1386663086613594113')
                }
                console.log(ids);
                this.$confirm(`确定删除所选项吗?`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$axios(this.api.user.systemporaryauthorityRemoveById, ids, 'post').then(data => {
                        if (data.status) {
                            this.$message.success('删除成功')
                            this.$refs.multipleTable.clearSelection()
                            this.refreshList()
                        } else {
                            this.$message.error(data.msg)
                        }
                    })
                })
            },
            // 多选
            selectionChangeHandle(val) {
                this.dataListSelections = val
            },
            reset() {
                this.$refs.multipleTable.clearSelection()
                this.$refs.searchForm.resetFields();
                this.refreshList(1)
            }
        }
    }
</script>

<style scoped>
    .mealName {
        background-color: #ebf5fd !important;
        border-color: #d7eafb !important;
        color: #3698E9 !important;
    }

    .mealName2 {
        background-color: #f0f9eb !important;
        border-color: #e1f3d8 !important;
        color: #67c23a !important;
    }
</style>
